import { _$ } from "/WebInterface/new-ui/assets/js/utils/dom.js";
import { apiCall } from "/WebInterface/new-ui/assets/js/utils/api/apis.js";
import Modal from "/WebInterface/new-ui/modules/modal.js";
import {
  connectionLostTemplate,
  electronUserInfoTemplate,
} from "/WebInterface/new-ui/upload/electron-app/template.js";
import { t } from "/WebInterface/new-ui/modules/localizations/localizations.js";
import Tooltip from "/WebInterface/new-ui/modules/tooltip/tooltip.js";
import { initShareHistoryModal } from "/WebInterface/new-ui/upload/electron-app/electron-share-history/electron-share-history.js";
import uploadingQueue from "/WebInterface/new-ui/upload/js/uploading-queue.js";

// To invoke parent methods
function invoke(method, params) {
  if (parent.window[method]) {
    return parent.window[method].apply(this, params);
  }
}

// keeping session calls track
let failedSessionCalls = 0;
let dialog;

// To keep session alive making user info call in 10 sec interval
const makeUserInfoCall = async () => {
  try {
    await apiCall("getUserInfo");

    // reseting failed session calls
    failedSessionCalls = 0;

    // hide connection lost modal
    if (dialog?.visible()) {
      dialog?.hide();
    }
  } catch (error) {
    // show connection lost modal
    if (!dialog?.visible()) {
      dialog?.show();
    }

    // updating failed session calls
    failedSessionCalls += 1;
  } finally {
    // if session calls failed 3 times
    if (failedSessionCalls === 3) {
      // refresh electron app
      const ipcRenderer = invoke("getIPCRenderer");
      ipcRenderer.send("user-logged-out");

      return;
    }

    _$("#try-now-button")?.el()?.removeAttribute("disabled");
    setTimeout(() => {
      makeUserInfoCall();
    }, 10000);
  }
};

const configureElectronApp = () => {
  _$("body").addClass("electron-app");

  _$(".electron-app-remove").remove();
  _$(".electron-app-hidden").addClass("is-hidden");
  _$(".electron-app-show").removeClass("is-hidden");

  const tooltip = new Tooltip();
  const tooltipElements = _$(".upload-action[data-tooltip]").sel();

  tooltipElements.forEach((element) => {
    const position = _$(element).attr("tooltip-position") || "bottom";
    tooltip.addTooltip({
      tooltipText: t(_$(element).attr("data-tooltip")),
      element,
      position,
    });
  });

  _$("#electronAppReloadButton").on("click", () => {
    location.reload();
  });

  const userInfo = invoke("getUserInfo");
  const path = invoke("currentPath");

  const { username } = userInfo;
  const { hostname, port } = location;

  _$("#electronAppInfoButton").attr(
    "data-tooltip",
    electronUserInfoTemplate({
      serverText: t("server"),
      userText: t("user"),
      pathText: t("path"),
      servername: `${hostname}:${port}`,
      username,
      path,
    })
  );

  _$("#electronAppLogoutButton").on("click", () => {
    if (uploadingQueue.fileUploadingInProgress) {
      const confirmation = window.confirm("Are you sure you want to logout?");
      if (confirmation) {
        invoke("logout");
      }
    } else {
      invoke("logout");
    }
  });

  _$("#electronAppQuitButton").on("click", () => {
    const quitApp = () => {
      const ipcRenderer = invoke("getIPCRenderer");
      ipcRenderer.send("quit-app");
    };

    if (uploadingQueue.fileUploadingInProgress) {
      const confirmation = window.confirm(
        "Are you sure you want to quit the app?"
      );
      if (confirmation) {
        quitApp();
      }
    } else {
      quitApp();
    }
  });

  _$("#electronAppShareHistoryButton").on("click", () => {
    initShareHistoryModal();
  });
};

const deconfigureElectronApp = () => {
  _$(".electron-app-show").remove();
};

// only for electron app
_$("body").ready(() => {
  const isElectronUploadOnlyApp = invoke("isElectron");

  if (!isElectronUploadOnlyApp) {
    deconfigureElectronApp();
    return;
  }

  dialog = new Modal({
    body: connectionLostTemplate({
      tryNowText: t("tryNow"),
      tryingToReconnectElectronAppText: t("tryingToReconnectElectronApp"),
    }),
    showHeader: false,
    closable: false,
    hasFooter: false,
    extraClasses: ["connection-lost-modal", "p-0"],
    buttons: [],
  });

  _$("#try-now-button").on("click", () => {
    _$("#try-now-button").attr("disabled", true);
    makeUserInfoCall();
  });

  makeUserInfoCall();
  configureElectronApp();
});
